// extracted by mini-css-extract-plugin
export default {"content":"styles_content__GFBA+","message":"styles_message__epa4H","dangerIcon":"styles_dangerIcon__TTujf","question":"styles_question__1gOUT","ban":"styles_ban__-8PeC"};